import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Container, Col, Row, Table, Button, Badge, Input, InputGroup, Form } from 'reactstrap';
import Pagination from 'react-js-pagination';
import MaterialIcon from 'material-icons-react';
import i18n from '../../../i18next';
import { NavLink } from 'react-router-dom';
import { Link } from 'react-router-dom';

import {
    ACCEPTED,
    REJECTED,
    CANCELED,
    DEFAULT_PAGE_SIZE,
    DEFAULT_PAGING_RANGE,
    INSTORE_ID,
    CURBSIDE_ID
} from '../../../utils/Constants';
import {
    getPriceWithCurrencySymbol,
    localizeCountryNames,
    localizeStatuses,
    renderOrderTypeSrc,
    renderPaymentTypeIcon,
    transformProductPrice,
    negativeIntegersValidation
} from '../../../utils/CommonUtils';
import { loadOrdersHistoryReports, clearOrdersHistory, getOrdersDetails, getRefundHistory, loadRestaurant, downloadOrderHistoryReports, getRestaurantGiftCardProviderSettings, getRestaurantGiftCardProviderTypeId } from '../../../actions/index';
import RestaurantUtils from '../../../utils/RestaurantUtils';
import OrderDetailsScreen from "./OrderDetailsScreen";
import SearchButton from '../../common/SearchButton';
import OrderSourceSelector from "../../common/OrderSourceSelector";
import { requestRange } from "../reports/ReportsScreen";

class OrdersHistoryReports extends Component {
    constructor(props) {
        super(props);

        this.state = {
            currency: '',
            filterQuery: {
                fromPlacedTime: '',
                toPlacedTime: '',
                orderStatus: ''
            },
            currentPageNumber: 1,
            orderDetailsScreenOpened: false,
            ordersTableReload: false,
            isLoading: false
        }

        this.handlePageChange = this.handlePageChange.bind(this);
        this.toggleOrderDetailsScreen = this.toggleOrderDetailsScreen.bind(this);
        this.statusFilterRequest = this.statusFilterRequest.bind(this);
        this.timeRangeFilterRequest = this.timeRangeFilterRequest.bind(this);
    }

    componentDidMount() {
        const restaurantId = this.props.restaurantId;
        this.props.getRestaurantGiftCardProviderTypeId(restaurantId);
        
        this.statusFilterRequest('');

        if (this.props.selectedTimeRange) {
          this.timeRangeFilterRequest(this.props.selectedTimeRange);
        }
    }

    componentDidUpdate(prevProps) {
        if (this.props.restaurantId !== prevProps.restaurantId) {
            const restaurantId = this.props.restaurantId;
            this.props.loadOrdersHistoryReports(restaurantId, 1, this.state.filterQuery);
        } else if (this.props.selectedTimeRange !== prevProps.selectedTimeRange) {
            this.timeRangeFilterRequest(this.props.selectedTimeRange);
        } else if (this.props.orders !== prevProps.orders) {
            if (this.props.orders.content !== undefined && this.props.orders.content !== null && this.props.orders.content.length && this.state.orderDetailsScreenOpened === false && this.state.ordersTableReload) {
                this.setState({
                    isLoading: true
                });
                this.filterReportsQuery(this.state.filterQuery, true);
            }
        }
    }

    componentWillUnmount() {
        this.props.clearOrdersHistory();
    }

    copyStateFromProps() {
        if (this.props.restaurant.currency !== undefined && this.props.restaurant.currency !== null &&
            this.props.restaurant.currency !== '' && !this.state.stateAlreadyCopiedFromProps) {

            this.setState({
                currency: this.props.restaurant.currency,
                stateAlreadyCopiedFromProps: true
            });
        }
    }

    rejectedOrderReseted() {
        const restaurantId = this.props.restaurantId;
        // this.props.loadOrdersHistoryReports(restaurantId, 1, this.state.filterQuery);
        this.props.loadOrdersHistoryReports(restaurantId, this.state.currentPageNumber, this.state.filterQuery);
    }

    loadOrderDetailsScreen(orderId) {
        const restaurantId = this.props.restaurantId;
        this.props.loadRestaurant(restaurantId);

        this.props.getOrdersDetails(orderId, () => {
            this.toggleOrderDetailsScreen();
        });

        this.props.getRefundHistory(orderId);
    }

    toggleOrderDetailsScreen(callbackFunction) {
        this.setState({
            orderDetailsScreenOpened: !this.state.orderDetailsScreenOpened
        }, () => {
            if (this.state.orderDetailsScreenOpened === false) {
                this.setState({
                    ordersTableReload: true
                });
            }

            if (callbackFunction) {
                callbackFunction()
            }
        });
    }

    handlePageChange(pageNumber) {
        const restaurantId = this.props.restaurantId;

        this.setState({
            currentPageNumber: pageNumber,
            ordersTableReload: false
        });

        this.props.loadOrdersHistoryReports(restaurantId, pageNumber, this.state.filterQuery);
    }

    timeRangeFilterRequest(requestedTimeRange) {
        this.setState({
            filterQuery: {
                ...this.state.filterQuery,
                fromPlacedTime: requestedTimeRange.startDate,
                toPlacedTime: requestedTimeRange.endDate
            }
        }, () => this.filterReportsQuery(this.state.filterQuery, false));
    };

    statusFilterRequest(requestedStatus) {
        this.setState({
            filterQuery: {
                ...this.state.filterQuery,
                orderStatus: requestedStatus,
            }
        }, () => this.filterReportsQuery(this.state.filterQuery, false));
     };

    filterReportsQuery(filterQuery, stayOnCurrPage) {
        this.setState({
            ordersTableReload: false
        });

        const pageNum = stayOnCurrPage ? this.state.currentPageNumber : 1;
        const restaurantId = this.props.restaurantId;
        this.props.loadOrdersHistoryReports(restaurantId, pageNum, filterQuery);

        setTimeout(() => {
            this.setState({
                isLoading: false
            });
        }, 500);
    }

    renderReportRangeOptions() {
        const { summary, colElement, reportRangeOptionsRow, underline } = styles;
        const currentSelection = Object.assign({}, colElement, underline);

        return (
            <Row style={reportRangeOptionsRow}>
                <Col xs={7} sm={7} style={summary}>
                    <span
                        style={(this.state.filterQuery.orderStatus === '') ? currentSelection : colElement}
                        onClick={() => this.statusFilterRequest('')}>{i18n.t('screens:restaurantsScreen.all')}</span>
                    <span
                        style={(this.state.filterQuery.orderStatus === ACCEPTED) ? currentSelection : colElement}
                        onClick={() => this.statusFilterRequest(ACCEPTED)}>{localizeStatuses(ACCEPTED)}</span>
                    <span
                        style={(this.state.filterQuery.orderStatus === CANCELED) ? currentSelection : colElement}
                        onClick={() => this.statusFilterRequest(CANCELED)}>{localizeStatuses(CANCELED)}</span>
                    <span
                        style={(this.state.filterQuery.orderStatus === REJECTED) ? currentSelection : colElement}
                        onClick={() => this.statusFilterRequest(REJECTED)}>{localizeStatuses(REJECTED)}</span>
                 </Col>
                 <Col xs={5} sm={5} style={{ display: 'flex', justifyContent: 'flex-end', paddingBottom: 34 }}>
                    <Button
                        color='primary'
                        onClick={() => this.props.downloadOrderHistoryReports(this.state.currentPageNumber, this.state.filterQuery, this.props.restaurantId)}
                        style={{ display: 'flex', justifyContent: 'space-around', alignItems: 'center' }}>
                        <MaterialIcon icon="cloud_download" color="#fff" size={19} />
                        <span style={{ marginLeft: 6 }}>{i18n.t('screens:orderHistoryScreen.downloadOrdersReport')}</span>
                    </Button>
                 </Col>
            </Row>
        );
    }

    renderReportInfo() {
        const { reportInfoContainer, reportInfo } = styles;
        
        let selectedRange = '';
        if (this.props.requestRangeSelection === requestRange.TODAY) {
          selectedRange = i18n.t('screens:reportsScreen.reportRangeToday');
        } else if (this.props.requestRangeSelection === requestRange.YESTERDAY) {
          selectedRange = i18n.t('screens:reportsScreen.reportRangeYesterday');
        } else if (this.props.requestRangeSelection === requestRange.TOMORROW) {
          selectedRange = i18n.t('screens:reportsScreen.reportRangeTomorrow');
        } else if (this.props.requestRangeSelection === requestRange.THIS_WEEK) {
          selectedRange = i18n.t('screens:reportsScreen.reportRangeThisWeek');
        } else if (this.props.requestRangeSelection === requestRange.LAST_WEEK) {
          selectedRange = i18n.t('screens:reportsScreen.reportRangeLastWeek');
        } else if (this.props.requestRangeSelection === requestRange.THIS_MONTH) {
          selectedRange = i18n.t('screens:reportsScreen.reportRangeThisMonth');
        } else if (this.props.requestRangeSelection === requestRange.LAST_MONTH) {
          selectedRange = i18n.t('screens:reportsScreen.reportRangeLastMonth');
        } else if (this.props.requestRangeSelection === requestRange.CUSTOM) {
          selectedRange = i18n.t('screens:reportsScreen.reportRangeCustom');
        }                	

        let selectedStatus = '';
        let selectedStatusColor = '';
        if (this.state.filterQuery.orderStatus === ACCEPTED) {
          selectedStatus = localizeStatuses(ACCEPTED);
          selectedStatusColor = RestaurantUtils.getOrderStatusColor(ACCEPTED);   
        } else if (this.state.filterQuery.orderStatus === CANCELED) {
          selectedStatus = localizeStatuses(CANCELED);
          selectedStatusColor = RestaurantUtils.getOrderStatusColor(CANCELED);
        } else if (this.state.filterQuery.orderStatus === REJECTED) {
          selectedStatus = localizeStatuses(REJECTED);
          selectedStatusColor = RestaurantUtils.getOrderStatusColor(REJECTED);
        } else {
          selectedStatus = i18n.t('screens:restaurantsScreen.all');
          selectedStatusColor = "#0288d1";           	        	
        }
        
        return (
            <div style={reportInfoContainer}>
                <div style={reportInfo}>
                    {i18n.t('screens:orderHistoryScreen.status')}:&nbsp;&nbsp;
                    <Badge style={{ fontSize: 14, backgroundColor: selectedStatusColor }}>&nbsp;{selectedStatus}&nbsp;</Badge>&nbsp;&nbsp;&nbsp;&nbsp;
                    {i18n.t('screens:loyaltyScreen.dateRange')}:&nbsp;&nbsp;
                    <Badge color="primary" style={{ fontSize: 14 }}>&nbsp;{selectedRange}&nbsp;</Badge>
                </div>
            </div>
        );
    }

    renderOrderHistoryTable() {
        const { textAlignCenter, hideElement, fadeInElement } = styles;
        let isLoading = this.state.isLoading;

        return (
            <Col>
                <Table responsive hover>
                    <thead>
                        <tr>
                            <th>{i18n.t('screens:orderHistoryScreen.orderIdTable')}</th>
                            <th>{i18n.t('screens:orderHistoryScreen.date')}</th>
                            <th>{i18n.t('screens:orderHistoryScreen.wantedTime')}</th>
                            <th>{i18n.t('screens:orderHistoryScreen.orderType')}</th>
                            <th>{i18n.t('screens:orderHistoryScreen.customerName')}</th>
                            <th>{i18n.t('screens:orderHistoryScreen.orderAddress')}</th>
                            <th style={textAlignCenter}>{i18n.t('screens:orderHistoryScreen.paymentType')}</th>
                            <th>{i18n.t('screens:orderDetailsScreen.totalPrice')}</th>
                            <th>{i18n.t('screens:orderHistoryScreen.status')}</th>
                            <th>{i18n.t('screens:orderHistoryScreen.source')}</th>
                            <th>{i18n.t('screens:orderDetailsScreen.rejectReason')}</th>
                        </tr>
                    </thead>
                    <tbody style={isLoading ? hideElement : fadeInElement}>{this.renderTableRows()}</tbody>
                </Table>
            </Col>
        );
    }

    renderTableRows() {
        const { selectOrderStyle, textAlignCenter, loyaltyIconStyle } = styles;
        const currency = this.state.currency;

        if (this.props.orders.content !== undefined && this.props.orders.content !== null && this.props.orders.content.length) {
            return this.props.orders.content.map((order, i) => {

                const orderStatusColor = RestaurantUtils.getOrderStatusColor(order.orderStatus);
                const statusColor = { color: orderStatusColor };

                let orderAddress = (order.orderAddress.fullAddress !== null) ? order.orderAddress.fullAddress : order.orderAddress.street + ', ' + order.orderAddress.city + ', ' + localizeCountryNames(order.orderAddress.country);
                if (order.orderType.id === INSTORE_ID) {
                    orderAddress = order.inStoreSeat;
                }
                let orderAddressValue = order.orderType.id === CURBSIDE_ID ? order.carDetails : orderAddress

                const orderTypeIconSrc = renderOrderTypeSrc(order.orderType.id);

                let paymentTypeIconSrc = renderPaymentTypeIcon(order.tenderType.id);
                const orderServiceFee = order.serviceFee ? order.serviceFee : 0;

                let renderLoyaltyIcon = order.paidWithVoucher;

                let price = parseFloat(order.priceTotal) + orderServiceFee;

                const priceTotalWithCurrency = getPriceWithCurrencySymbol(transformProductPrice(price), currency);

                const isOnlyLoyalty = renderLoyaltyIcon && price === 0 ? true : false;

                if (isOnlyLoyalty) {
                    paymentTypeIconSrc = null;
                }

                const isLoyaltyIconStyle = renderLoyaltyIcon && paymentTypeIconSrc ? loyaltyIconStyle : null;
                const loyaltyIconSrc = renderPaymentTypeIcon(3, isLoyaltyIconStyle, isOnlyLoyalty); // Loyalty fake id
                const isGiftCardDiscount = order.giftCardDiscount ? true : false;

                return (
                    <tr key={i}>
                        <td style={selectOrderStyle} onClick={() => this.loadOrderDetailsScreen(order.orderId)}>{order.orderId}</td>
                        <td>{order.date}</td>
                        <td>{order.wantedTime}</td>
                        <td style={textAlignCenter}>{orderTypeIconSrc}</td>
                        <td>
                            <NavLink tag={Link} style={selectOrderStyle} to={`/restaurant/${this.props.restaurantId}/customer-insight/${order.customerId}`}>
                                {order.customerName}
                            </NavLink>
                        </td>
                        <td>{orderAddressValue}</td>
                        <td style={textAlignCenter}>
                            <div style={{display: 'flex'}}>
                            {
                                renderLoyaltyIcon && paymentTypeIconSrc ?
                                    <React.Fragment>
                                        <span style={{ display: 'flex', justifyContent: 'space-evenly' }}>
                                            {paymentTypeIconSrc}
                                            {loyaltyIconSrc}
                                        </span>
                                    </React.Fragment> :
                                    renderLoyaltyIcon && !paymentTypeIconSrc ? loyaltyIconSrc : paymentTypeIconSrc
                            }
                            {
                                isGiftCardDiscount ? 
                                <span style={{marginLeft: '11px'}}>
                                    <MaterialIcon icon="card_giftcard" size={28} width={24} height={26} color='#0288d1' />
                                </span> : null
                            }
                            </div>
                        </td>
                        <td>{priceTotalWithCurrency}</td>
                        <td><span style={statusColor}>{(order.orderStatus !== null) ? localizeStatuses(order.orderStatus) : i18n.t('screens:orderHistoryScreen.noStatus')}</span></td>
                        <td><OrderSourceSelector source={order.source} /></td>
                        <td>{order.rejectReason ? i18n.t(`screens:mainContainer.${order.rejectReason}`) : null}</td>
                    </tr>
                );
            });
        }
    }

    renderPagination() {
        const { flexEnd } = styles;

        return (
            <Col style={flexEnd}>
                <Pagination
                    activePage={this.props.orders.number + 1}
                    itemsCountPerPage={DEFAULT_PAGE_SIZE}
                    totalItemsCount={this.props.orders.totalElements}
                    pageRangeDisplayed={DEFAULT_PAGING_RANGE}
                    itemClass='page-item'
                    linkClass='page-link'
                    onChange={this.handlePageChange}
                />
            </Col>
        );
    }

    refreshResults() {
        const restaurantId = this.props.restaurantId;
        this.props.loadOrdersHistoryReports(restaurantId, this.state.currentPageNumber, this.state.filterQuery);
    }

    render() {
        const { containerStyle } = styles;
        const restaurantId = this.props.restaurantId;

        this.copyStateFromProps();

        return (
            <Container fluid style={containerStyle}>
                {this.renderReportRangeOptions()}
                {this.renderReportInfo()}
                <Row>{this.renderOrderHistoryTable()}</Row>
                <Row>{this.renderPagination()}</Row>
                {this.state.orderDetailsScreenOpened ? <OrderDetailsScreen
                    isOpen={this.state.orderDetailsScreenOpened}
                    onToggle={this.toggleOrderDetailsScreen}
                    orderDetails={this.props.orderDetails}
                    currency={this.state.currency}
                    restaurantId={restaurantId}
                    currentPageNumber={this.state.currentPageNumber}
                    rejectedOrderReseted={this.rejectedOrderReseted.bind(this)}
                    refreshResults={this.refreshResults.bind(this)}
                    giftCardProviderType={this.props.giftCardProvider.restaurantGiftCardProviderTypeId ? this.props.giftCardProvider.restaurantGiftCardProviderTypeId.type : null}
                /> : null}
            </Container>
        );
    }
}

const mapStateToProps = state => {
    return {
        orders: state.orders,
        restaurant: state.restaurant,
        orderDetails: state.оrderDetails,
        giftCardProvider: state.giftCardProvider
    }
}

export default connect(mapStateToProps, { loadOrdersHistoryReports, clearOrdersHistory, getOrdersDetails, getRefundHistory, loadRestaurant, downloadOrderHistoryReports, getRestaurantGiftCardProviderSettings, getRestaurantGiftCardProviderTypeId })(OrdersHistoryReports);

let styles = {
    containerStyle: {
        width: '100%',
        marginTop: 20
    },
    flexEnd: {
        display: 'flex',
        justifyContent: 'flex-end',
        paddingRight: 0
    },
    selectOrderStyle: {
        color: '#0087d7',
        cursor: 'pointer'
    },
    textAlignCenter: {
        textAlign: 'center'
    },
    loyaltyIconStyle: {
        marginLeft: '11px'
    },
    reportRangeOptionsRow: {
        paddingTop: 33
    },
    colElement: {
        marginRight: 20,
        color: '#0288D1',
        cursor: 'pointer',
        fontSize: 14
    },
    underline: {
        textDecoration: 'underline'
    },
    reportInfoContainer: {
        width: '100%',
        marginBottom: 30,
        boxShadow: '1px 6px 24px 0px rgba(0,0,0,0.4)',
        display: 'flex',
        justifyContent: 'space-between'
    },
    reportInfo: {
        padding: 20,
        fontSize: 14,
    },
    hideElement: {
        opacity: 0
    },
    fadeInElement: {
        opacity: 1,
        transition: 'opacity 0.45s ease'
    }
}



// WEBPACK FOOTER //
// ./src/components/restaurants/orders/OrdersHistoryReports.js